import { rootMeanSquareDifference } from "./index140.js";
import { getDistribution } from "./index149.js";
function getUnitMixCost(state, props) {
	return rootMeanSquareDifference(getDistribution(state.sequence, props), props.targetUnitMix.map((m) => m.ratio));
}
export { getUnitMixCost };

//# sourceMappingURL=index150.js.map